<template>
  <div style="padding-top: 20px; padding-bottom: 20px;">
    <h3>{{ this.$route.params.site }}</h3>
    <div v-if="site === undefined">
      <h4>Diese Seite hat noch keinen Inhalt.</h4>
    </div>
    <div
      v-else-if="!site.private || site.unlocked"
    >
      <div
        v-for="section in sections"
        :key="section.id"
      >
        <h6
          class="font-weight-bold"
          style="border-bottom: 1px solid black; font-size: 18px;"
        >
          {{ section.name }}
        </h6>
        <TextSection
          v-if="section.type === 'wysiwyg'"
          :id="section.id"
        />
        <CarouselSection
          v-else-if="section.type === 'slider'"
          :id="section.id"
        />
        <FileSection
          v-else-if="section.type === 'files'"
          :id="section.id"
        />
        <div
          v-else
        >
          Error
        </div>
      </div>
    </div>
    <div
      v-else
    >
      Diese Seite ist nicht für den öffentlichen Gebrauch. Bitte geben Sie das Passwort ein, um diese Seite aufzurufen.<br>
      <label for="key">Passwort:</label>
      <b-form-input
        id="key"
        v-model="key"
        @keyup.enter="saveKey"
      />
      <b-button
        variant="success"
        class="mt-2"
        block
        @click="saveKey"
      >
        Entsperren
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TextSection from '@/components/CMS/TextSection'
import CarouselSection from '@/components/CMS/CarouselSection'
import FileSection from '@/components/CMS/FileSection'

export default {
  name: 'Site',
  components: {
    FileSection,
    CarouselSection,
    TextSection
  },
  data () {
    return {
      key: ''
    }
  },
  computed: {
    ...mapGetters([
      'getStoredSectionsBySiteId',
      'getStoredSiteById'
    ]),
    sections () {
      return this.getStoredSectionsBySiteId(this.$route.params.siteId)
    },
    site () {
      return this.getStoredSiteById(parseInt(this.$route.params.siteId))
    }
  },
  watch: {
    $route (to) {
      this.getSectionsForSite(to.params.siteId)
    }
  },
  mounted () {
    this.getSectionsForSite(this.$route.params.siteId)
    this.getSite(this.$route.params.siteId)
  },
  methods: {
    ...mapMutations([
      'setKey'
    ]),
    ...mapActions([
      'getSectionsForSite',
      'getSite'
    ]),
    saveKey () {
      this.setKey(this.key)
      this.getSectionsForSite(this.$route.params.siteId)
    }
  }
}
</script>

<style>
img {
  max-width: 100%;
}
</style>
